// assets
import { IconSettings } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| SETTINGS MENU ITEM ||============================== //

const icons = {
  IconSettings
};

const settings: NavItemType = {
  id: 'settings',
  title: 'settings',
  icon: icons.IconSettings,
  type: 'group',
  url: '/settings'
};

export default settings;
